import { STANDARD_RATE_ADDITIONAL_TAX_CATEGORY_CODE } from '../utils/taxCategoryUtils';

export function standardRateAdditionalTaxRatePositiveTest(value) {
  const { id } = this.parent;

  if (id !== STANDARD_RATE_ADDITIONAL_TAX_CATEGORY_CODE) {
    return true;
  }

  return value != null && Number(value) > 0;
}
